import $ from 'jquery';

let navigationPanel = {
  initialize: function () {

    let $parents = $('[data-navigation-panel-parent]');
    let $body = $('body');

    let setIsInert = (isInert) => {
      document.querySelectorAll('.c-navigation-social-links').forEach((element) => {
        element.toggleAttribute('inert', isInert);
      });
    };

    $parents.each(function () {
      let $parent = $(this);

      $parent.find('[aria-haspopup]').on('click', function (event) {
        event.preventDefault();

        let $anchor = $(this);
        let colorScheme = $anchor.closest('[data-color-scheme]').attr('data-color-scheme');
        let height = $parent.find('.c-navigation-panel').outerHeight() - $('.c-navigation-utility').outerHeight();

        if ($anchor.attr('aria-expanded') === 'true') {
          $parent.removeAttr('data-has-expanded-panel');
          $anchor.attr('aria-expanded', 'false');
          document.querySelector('.c-navigation-header__navigation-utility').style.removeProperty('--transform-y');
          $body.removeAttr('data-color-scheme-active');
          $body.removeClass('body--main-navigation-panel-opened');
          setIsInert(true);
        } else {
          $parents.removeAttr('data-has-expanded-panel');
          $parent.attr('data-has-expanded-panel', 'true');
          $parents.find('[aria-haspopup]').attr('aria-expanded', 'false');
          $anchor.attr('aria-expanded', 'true');
          document.querySelector('.c-navigation-header__navigation-utility').style.setProperty('--transform-y', height + 'px');
          $body.attr('data-color-scheme-active', colorScheme);
          $body.addClass('body--main-navigation-panel-opened');
          setIsInert(false);
          $parent.find('.js-search-input').each(function () {
            this.focus();
          });
          $parent.find('.js-username-input').each(function () {
            this.focus();
          });
        }
      });
    });

    setIsInert(true);
  }
};

navigationPanel.initialize();
